import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

// Define a service using a base URL and expected endpoints
export const parkingsSlotApi = createApi({
  reducerPath: 'parkingsSlotApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkingsSlot'],
  endpoints: (builder) => ({
    findAllServiceDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingSlotController.findAllServiceDetail,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    findParkingSlotById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.parkingSlotController.findParkingSlotById}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
    getParkingsOnSearch: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingSlotController.getParkingsOnSearch,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    saveParkingSlot: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingSlotController.saveParkingSlot,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});
// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindAllServiceDetailMutation, useFindParkingSlotByIdMutation, useGetParkingsOnSearchMutation,
  useSaveParkingSlotMutation } =
  parkingsSlotApi;
